import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

type BusquedaEnResultadosFieldProps = {
  onDebouncedChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
};

const BusquedaEnResultadosField: React.FC<BusquedaEnResultadosFieldProps> = ({
  onDebouncedChange,
  placeholder = 'Cliente, artículo, comprobante o master',
  debounceMs = 300,
}) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      onDebouncedChange(value.trim().toLowerCase());
    }, debounceMs);
    return () => window.clearTimeout(timeoutId);
  }, [value, debounceMs, onDebouncedChange]);

  return (
    <TextField
      label="Buscar en resultados"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      size="small"
      fullWidth
    />
  );
};

export default BusquedaEnResultadosField;
